<template>
  <div id="app" :class="{'g-gray': infoData.gray==='1', 'is-mobile': isMobile}">
    <!-- 重大事件 -->
    <div class="event-box" @click="goDetail" v-show="infoData.vip==='1'">
      <div class="pic-box">
        <img v-lazy="infoData.imgUrl" alt="">
        <!-- <p class="txt">{{infoData.title}}</p> -->
      </div>
    </div>
    <!-- <router-view /> -->
      <router-view />
    <cmpBackTop></cmpBackTop>
  </div>
</template>

<script>
import cmpBackTop from '@cmp/back-top'
export default {
  components: { cmpBackTop },
  name: 'app',
  data() {
    return {
      infoData: {},
      isMobile: false
    }
  },
  methods: {
    getData() {
      this.$http.get('../singleMuseum/webapi/index', {}).then((res) => {
        if (res.success) {
          this.infoData = res.result.info
        } else {
          this.$message.error(res.message)
        }
      })
    },
    // 判断移动端还是pc端
    _isMobile() {
      this.isMobile = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      )

      this.$store.state.app.isMobile = this.isMobile
    },
    goDetail() {
      window.open(this.infoData.url)
    }
  },
  created() {
    this._isMobile()
    this.getData()
  }
}
</script>

<style lang="scss">
.g-gray {
  filter: grayscale(100%);
  -webkit-filter: grayscale(100%);
  -moz-filter: grayscale(100%);
  -ms-filter: grayscale(100%);
  -o-filter: grayscale(100%);
  filter: url('data:image/svg+xml;utf8,#grayscale');
  filter: progid:DXImageTransform.Microsoft.BasicImage(grayscale=1);
  -webkit-filter: grayscale(1);
}
.event-box {
  // background: red;
  font-size: 30px;
  .pic-box {
    position: relative;
    margin: 0 auto;
    text-align: center;
    img {
      width: 100%;
      height: 60px;
      object-fit: cover;
    }
    .txt {
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      line-height: 60px;
      text-align: center;
      color: #fff;
    }
  }
}
@import './assets/css/reset.css';
@import './assets/css/element-variables.scss';
@import '~@/assets/css/theme.scss';
</style>

